<template>
  <v-card
    max-width="97%"
    height="403px"
    elevation="0"
    class="mx-0 mt-3 scroll-vertical"
  >
    <v-data-table
      :headers="headers"
      :items="users"
      :items-per-page="5"
      class="elevation-1"
    >
      <!-- Customizing the DataTable with avatar -->
      <template v-slot:[`item.avatar`]="{ item }">
        <v-avatar color="primary_whiten" size="38" class="avatar-style">
          <span class="white--text headline">{{ item.avatar }}</span>
        </v-avatar>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  name: "RegisteredUsers",
  async created() {
    await this.fetchLatestUsers();
  },
  computed: {
    ...mapFields("users", ["latestUsers"]),
  },
  data: () => ({
    headers: [
      {
        text: "Avatar",
        align: "start",
        sortable: false,
        value: "avatar",
      },
      {
        text: "Name",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Phone", value: "phone" },
      { text: "Country", sortable: false, value: "country" },
      { text: "City", value: "city" },
    ],
    users: [],
  }),
  methods: {
    ...mapActions("users", ["fetchLatestUsers"]),
  },
  watch: {
    latestUsers: {
      immidate: true,
      handler(value) {
        if (value.length != 0) {
          value.map((user) => {
            this.users.push({
              avatar: "ET",
              name: user.name,
              phone: user.phone_number,
              country: user.country,
              city: user.city,
            });
          });
        }
      },
    },
  },
};
</script>